// src/core/FeaturePathMenus.ts

export interface PathMenuItem {
    url_id: string;
    url_path: string;
}

// Webpack scans feature/ at BUILD TIME for all pathMenus.ts files
const pathMenuModules = require.context(
    '../feature',    // relative path from this file
    true,            // search subdirectories
    /pathMenus\.ts$/ // match files named pathMenus.ts
);

// Aggregate all path menus from features
export const FeaturePathMenus: PathMenuItem[] = [];

pathMenuModules.keys().forEach((modulePath: any) => {
    const module = pathMenuModules(modulePath);

    // Each pathMenus.ts exports { pathMenus: PathMenuItem[] }
    if (module.pathMenus) {
        FeaturePathMenus.push(...module.pathMenus);
    }
});
